export const EDITABLE_LAYERS_GROUP = 'user_layers';
export const URL_ZOOM_OFFSET = 1; // zoom needs offset by 1 compared to osm.org, see #13027
export const DEFAULT_OSM_EDITOR = 'osm';
